export const REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS = 'providers'

export const REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_IS_PROVIDERS_INVITATION =
  'isProvidersInvitation'

export const REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS_COMMENT =
  'providersComment'

export const REQUEST_PROFILE_WIDGET_PROVIDERS_RECOMMENDATION_TYPE = {
  building: 'building',
  buildingAndCategory: 'building_and_category',
  category: 'category',
}

export const REQUEST_PROFILE_WIDGET_PROVIDERS_ADD_RECOMMENDED_PROVIDER_QA_NAME =
  'requestProfileProvidersAddRecommendedProvider'

export const REQUEST_PROFILE_WIDGET_PROVIDERS_ADD_SELECTED_PROVIDER_QA_NAME =
  'requestProfileProvidersAddSelectedProvider'
